// Система достижений и badges

export const ACHIEVEMENTS = [
  {
    id: 'first_recovery',
    title: '🎯 Первый Шаг',
    description: 'Восстановите свою первую подписку',
    icon: '🎯',
    requirement: { type: 'total_recovered', value: 1 },
    reward: 'Разблокирована тема "Новичок"',
    rarity: 'common'
  },
  {
    id: 'speed_demon',
    title: '⚡ Спидран',
    description: 'Восстановите подписку менее чем за 30 секунд',
    icon: '⚡',
    requirement: { type: 'speed', value: 30 },
    reward: 'Badge "Молния"',
    rarity: 'rare'
  },
  {
    id: 'phoenix',
    title: '🔥 Феникс',
    description: 'Используйте сервис 7 дней подряд',
    icon: '🔥',
    requirement: { type: 'streak', value: 7 },
    reward: 'Уникальная анимация огня',
    rarity: 'epic'
  },
  {
    id: 'collector',
    title: '📦 Коллекционер',
    description: 'Сохраните 10 подписок в истории',
    icon: '📦',
    requirement: { type: 'history_size', value: 10 },
    reward: 'Увеличен лимит истории до 20',
    rarity: 'common'
  },
  {
    id: 'social_butterfly',
    title: '🦋 Социальная Бабочка',
    description: 'Поделитесь подпиской в Telegram 5 раз',
    icon: '🦋',
    requirement: { type: 'shares', value: 5 },
    reward: 'Badge "Делиться - значит заботиться"',
    rarity: 'uncommon'
  },
  {
    id: 'organizer',
    title: '🏷️ Организатор',
    description: 'Добавьте теги к 5 подпискам',
    icon: '🏷️',
    requirement: { type: 'tags_used', value: 5 },
    reward: 'Разблокированы кастомные теги',
    rarity: 'uncommon'
  },
  {
    id: 'night_owl',
    title: '🦉 Ночная Сова',
    description: 'Восстановите подписку между 00:00 и 05:00',
    icon: '🦉',
    requirement: { type: 'time_of_day', value: 'night' },
    reward: 'Тёмная тема разблокирована',
    rarity: 'rare'
  },
  {
    id: 'early_bird',
    title: '🐦 Ранняя Пташка',
    description: 'Восстановите подписку между 05:00 и 07:00',
    icon: '🐦',
    requirement: { type: 'time_of_day', value: 'early' },
    reward: 'Светлая пастельная тема',
    rarity: 'uncommon'
  },
  {
    id: 'power_user',
    title: '⚙️ Опытный Пользователь',
    description: 'Используйте все функции сервиса',
    icon: '⚙️',
    requirement: { type: 'features_used', value: 10 },
    reward: 'Badge "Профи"',
    rarity: 'epic'
  },
  {
    id: 'master',
    title: '🔥 Мастер',
    description: 'Восстановите 10 подписок',
    icon: '🔥',
    requirement: { type: 'total_recovered', value: 10 },
    reward: 'Золотая рамка профиля',
    rarity: 'rare'
  },
  {
    id: 'legend',
    title: '🏆 Легенда',
    description: 'Восстановите 50 подписок',
    icon: '🏆',
    requirement: { type: 'total_recovered', value: 50 },
    reward: 'Платиновый badge + эксклюзивная тема',
    rarity: 'legendary'
  },
  {
    id: 'perfectionist',
    title: '💎 Перфекционист',
    description: 'Добавьте заметки и теги ко всем подпискам',
    icon: '💎',
    requirement: { type: 'all_organized', value: true },
    reward: 'Badge "Идеальный порядок"',
    rarity: 'epic'
  },
  {
    id: 'explorer',
    title: '🗺️ Исследователь',
    description: 'Попробуйте все VPN клиенты (откройте инструкции для всех)',
    icon: '🗺️',
    requirement: { type: 'vpn_clients_explored', value: 6 },
    reward: 'Badge "Знаток VPN"',
    rarity: 'rare'
  },
  {
    id: 'supporter',
    title: '💖 Поддержка',
    description: 'Оцените сервис на 5 звезд',
    icon: '💖',
    requirement: { type: 'rating', value: 5 },
    reward: 'Спасибо! ❤️',
    rarity: 'common'
  }
];

// Редкость достижений
export const RARITY_COLORS = {
  common: { bg: '#9CA3AF', text: 'Обычное', glow: '#D1D5DB' },
  uncommon: { bg: '#10B981', text: 'Необычное', glow: '#34D399' },
  rare: { bg: '#3B82F6', text: 'Редкое', glow: '#60A5FA' },
  epic: { bg: '#8B5CF6', text: 'Эпическое', glow: '#A78BFA' },
  legendary: { bg: '#F59E0B', text: 'Легендарное', glow: '#FBBF24' }
};

// Проверка получения достижения
export const checkAchievement = (achievementId, userStats) => {
  const achievement = ACHIEVEMENTS.find(a => a.id === achievementId);
  if (!achievement) return false;

  const { type, value } = achievement.requirement;

  switch (type) {
    case 'total_recovered':
      return userStats.totalRestored >= value;
    case 'streak':
      return userStats.currentStreak >= value;
    case 'history_size':
      return userStats.historySize >= value;
    case 'shares':
      return (userStats.shares || 0) >= value;
    case 'tags_used':
      return (userStats.tagsUsed || 0) >= value;
    case 'features_used':
      return (userStats.featuresUsed || 0) >= value;
    case 'vpn_clients_explored':
      return (userStats.vpnClientsExplored || 0) >= value;
    case 'rating':
      return (userStats.userRating || 0) >= value;
    case 'time_of_day':
      const hour = new Date().getHours();
      if (value === 'night') return hour >= 0 && hour < 5;
      if (value === 'early') return hour >= 5 && hour < 7;
      return false;
    case 'speed':
      return (userStats.lastRecoverySpeed || Infinity) < value;
    case 'all_organized':
      return userStats.allOrganized === true;
    default:
      return false;
  }
};

// Получить все разблокированные достижения
export const getUnlockedAchievements = (userStats) => {
  return ACHIEVEMENTS.filter(achievement => 
    checkAchievement(achievement.id, userStats)
  );
};

// Получить прогресс по достижению
export const getAchievementProgress = (achievementId, userStats) => {
  const achievement = ACHIEVEMENTS.find(a => a.id === achievementId);
  if (!achievement) return 0;

  const { type, value } = achievement.requirement;

  switch (type) {
    case 'total_recovered':
      return Math.min(100, (userStats.totalRestored / value) * 100);
    case 'streak':
      return Math.min(100, (userStats.currentStreak / value) * 100);
    case 'history_size':
      return Math.min(100, (userStats.historySize / value) * 100);
    case 'shares':
      return Math.min(100, ((userStats.shares || 0) / value) * 100);
    case 'tags_used':
      return Math.min(100, ((userStats.tagsUsed || 0) / value) * 100);
    case 'features_used':
      return Math.min(100, ((userStats.featuresUsed || 0) / value) * 100);
    case 'vpn_clients_explored':
      return Math.min(100, ((userStats.vpnClientsExplored || 0) / value) * 100);
    default:
      return 0;
  }
};











